const isAuthenticated = () => {
    if(localStorage.vuex) {
        const localSt = JSON.parse(localStorage.vuex);
        return localSt.authenticated
    }
    return false;
}

export default {
    isAuthenticated
}